import { registerPlugin } from "@capacitor/core";
import i18n from "i18next";
import { Geolocation } from "@capacitor/geolocation";
import { BackgroundGeolocationPlugin } from "@capacitor-community/background-geolocation";
import { debugAlert } from "./get-position-from-watch-or-demand";
const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>(
  "BackgroundGeolocation"
);

export type Position = {
  coords: { latitude: number; longitude: number; accuracy: number };
};

let lastKnownPosition: Position | null = null;

export const startLocationWatch = async (
  enableWhileInBackground: boolean
): Promise<void> => {
  //console.info("## Starting location watcher...");

  // Seed initial position immediately (also triggers permission prompt on iOS)
  try {
    const initial = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 5000,
    });
    if (initial) {
      debugAlert("10. Initial background position fetched");
      lastKnownPosition = {
        coords: {
          latitude: initial.coords.latitude,
          longitude: initial.coords.longitude,
          accuracy: initial.coords.accuracy,
        },
      };
      //console.info("## Seeded initial position:", lastKnownPosition);
    }
  } catch (err) {
    console.warn("## Failed to seed initial position:", err);
    debugAlert("11. Failed to set initial background position");
  }

  await BackgroundGeolocation.addWatcher(
    {
      distanceFilter: 10,
      ...(enableWhileInBackground && {
        backgroundMessage: i18n.t("backgroundMessage", { ns: "gps" }),
        backgroundTitle: i18n.t("backgroundTitle", { ns: "gps" }),
      }),
    },
    (location, error) => {
      //console.log("## location watcher callback", { location, error });
      if (error) {
        console.error("Error watching position:", error);
        lastKnownPosition = null;
        return;
      }
      debugAlert(
        "12. Background watch got new position, this should be used further on"
      );
      if (location) {
        // console.log('### location accuracy', location.accuracy)
        lastKnownPosition = {
          coords: {
            latitude: location.latitude,
            longitude: location.longitude,
            accuracy: location.accuracy,
          },
        };
        //console.info("## Updated last known position:", lastKnownPosition);
      }
    }
  );
};

export const getLastKnownPosition = (): Position | null => {
  // console.log('### get last known position')
  return lastKnownPosition;
};
